import React from 'react';
import { Plus, Pencil, Trash2 } from 'lucide-react';

export const AddButton = ({ onClick, label = 'Add' }) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-dashed border-[#3a2359] text-[#3a2359] text-xs uppercase tracking-wider hover:bg-[#3a2359] hover:text-white hover:border-solid"
  >
    <Plus size={14} /> {label}
  </button>
);

export const EditButton = ({ onClick, className = '' }) => (
  <button
    type="button"
    onClick={(e) => { e.stopPropagation(); e.preventDefault(); onClick(); }}
    className={`inline-flex items-center justify-center w-8 h-8 border border-[#3a2359] text-[#3a2359] bg-white hover:bg-[#3a2359] hover:text-white ${className}`}
    aria-label="Edit"
  >
    <Pencil size={13} />
  </button>
);

export const DeleteButton = ({ onClick, className = '' }) => (
  <button
    type="button"
    onClick={(e) => { e.stopPropagation(); e.preventDefault(); onClick(); }}
    className={`inline-flex items-center justify-center w-8 h-8 border border-[#a63a3a] text-[#a63a3a] bg-white hover:bg-[#a63a3a] hover:text-white ${className}`}
    aria-label="Delete"
  >
    <Trash2 size={13} />
  </button>
);

/** Floating edit/delete cluster positioned in top-right of a card (parent must be relative). */
export const CardControls = ({ onEdit, onDelete }) => (
  <div className="absolute top-2 right-2 flex gap-1.5 opacity-0 group-hover:opacity-100 focus-within:opacity-100 z-10">
    {onEdit && <EditButton onClick={onEdit} />}
    {onDelete && <DeleteButton onClick={onDelete} />}
  </div>
);
